import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Row, Skeleton } from "antd";
import moment from "moment";

import commentApi from "../../../apis/Comment.api";

const convertCategory = (item) => {
	if (item?.category_type === "ingredient") {
		return `성분별 > ${item.category_name}`;
	} else if (item?.category_type === "function") {
		return `고민별 > ${item.category_name}`;
	} else if (item?.category_type === "combination") {
		return `조합별 > ${item.category_name}`;
	} else if (item?.category_type === "recommend_nutrients") {
		return "문의글";
	} else if (item?.category_type === "cooperate") {
		return "공동구매";
	} else if (item?.category_type === "health_magazine") {
		return "건강 매거진";
	} else if (item?.category_type === "community") {
		return `소통`;
	} else if (item?.category_type === "mission") {
		return "클래스";
	} else if (item?.category_type === "event") {
		return "이벤트";
	}
};
const UnAnsweredComment = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);

	const [commentList, setCommentList] = useState([]);

	useEffect(() => {
		if (user?.id) {
			getCommentList();
		}
	}, [user]);

	const getCommentList = useCallback(async () => {
		setLoading(true);
		const param = {
			offset: 0,
			pageSize: 3,
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			answerStatus: 1,
			category: "all",
			searchWord: "",
		};
		const res = await commentApi.adminReadComment(param);
		if (res.code === 200) {
			setCommentList(res.result?.commentDTOList);
		}
		setLoading(false);
	}, []);

	return (
		<div
			className={`border-top`}
			style={{
				width: "100%",
				padding: "1.5em 0 0",
				display: "flex",
				flexDirection: "column",
				gap: "0.5em",
			}}
		>
			<h4>응답하지 않은 댓글</h4>

			<Skeleton
				loading={loading}
				active={loading}
				size={"large"}
				block={true}
				style={{
					height: "6em",
					padding: "1em 0",
				}}
				title={null}
				paragraph={{
					rows: 5,
					width: "100%",
				}}
			>
				<div className={`dashboard-comments-list-div`}>
					{commentList?.map((comment, idx) => (
						<div
							className={`dashboard-comment-each`}
							key={`comment-each-${idx}`}
							style={
								idx === 0
									? {
											paddingTop: 0,
									  }
									: {}
							}
						>
							<div className={`comment-information`}>
								<p className={`created_by_name`}>{comment?.created_by_name}</p>
								<p>ㆍ</p>
								<p className={`created_at`}>
									{moment(moment(comment?.created_at), "YYYY.MM.DD").fromNow()}
								</p>
								<p
									className={`comment-parents-circle`}
									style={{ marginLeft: "auto" }}
								>
									{convertCategory(comment)}
								</p>
							</div>
							<p className={`comment-text`}>
								{!!comment?.content && !!comment?.content?.trim()
									? comment?.content
									: comment?.imageList
									? "첨부된 이미지가 존재합니다."
									: "댓글 내용이 없습니다."}
							</p>
						</div>
					))}
				</div>
			</Skeleton>
			{!commentList?.length && !loading && (
				<Row
					align={"middle"}
					style={{
						width: "100%",
						flexDirection: "column",
						padding: "2em 0",
					}}
				>
					<img
						src={`/assets/images/warning.png`}
						alt={`warning-icon`}
						style={{
							width: "3em",
							height: "auto",
						}}
					/>
					<p
						style={{
							marginTop: "1em",
							color: "#adb5bd",
							fontSize: "1.1em",
							fontWeight: 500,
						}}
					>
						응답하지 않은 댓글이 없습니다.
					</p>
				</Row>
			)}
		</div>
	);
};
export default UnAnsweredComment;
